module.exports = __webpack_public_path__ + "img/danger.5e3b8ccf.svg";